import { AutogenModelEdiCommControlLookup, AutogenRowEdiCommControlLookup } from "./autogen/AutogenModelEdiCommControlLookup";

export class ModelEdiCommControlLookup extends AutogenModelEdiCommControlLookup<RowEdiCommControlLookup> {
	constructor() {
		super(RowEdiCommControlLookup);
	}
}

export class RowEdiCommControlLookup extends AutogenRowEdiCommControlLookup {
}